enum GridType {
    Foto = "Foto",
    User = "User",
    Document = "Document",
    Image = "Image",
    FamilyTree = "FamilyTree",
    Media = "Media",
    Book = "Book",
    Person="Person",

    Groups = "Groups",
    Svedocenja = "Svedocenja",
}
export const GridTypeMap= { Foto: ["Фото"], User: [], Person:[], Document: ["Документи"], Image: ["Слике"], FamilyTree: ["Родослови"], Media:["Видео","Текст"], Book:["Књига"], Groups:["Групе"], Svedocenja:["Видео"] };
export default GridType;